import * as React from "react";

import CardVideo from '../CardVideo';
import { CardVideoProps } from '../CardVideo/CardVideo';

import s from './SmallVideo.module.scss';

const SmallVideo: React.FC<CardVideoProps> = (props) => {
    return (
        <div className={s.Root}>
            <div className={s.Wrapper}>
                <CardVideo {...props} />
            </div>
        </div>
    )
};

export default SmallVideo;
